import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';

export class Tracking {

  public static init() {
    // Facebook Pixel
    ReactPixel.init('1102495797339947');
    ReactPixel.pageView();

    // Google Analytics
    ReactGA.initialize('G-P0HTMD0DF8');
    ReactGA.send({ hitType: 'pageview', page: (window.location.pathname + window.location.search) });
  }

  public static track(eventName: string, parameters: any) {
    // Facebook Pixel
    this.trackFB(eventName, parameters);
    this.trackGA(eventName);

  }

  public static trackFB(eventName: string, parameters: any) {
    // Facebook Pixel
    ReactPixel.track(eventName, parameters);

  }

  public static trackGA(eventName: string) {
    // Google Analytics
    ReactGA.event({
      category: 'Cita Online',
      action: eventName,
    });


  }

  public static trackBuscarOpticas() {
    this.trackFB('FindLocation', {});
    this.trackGA('FindLocation');
  }

  public static trackOpticaSelecionada(optic_id: string) {
    this.track('OpticaSelecionada', { optic_id });
  }

  public static trackHoraSeleccionada(optic_id: string) {
    this.track('hora_selecionada_cita_online', { optic_id });
  }

  public static trackCitaReservada(optic_id: string) {
    this.track('Schedule', { optic_id });
  }

  // CJ Affiliate: click id guardado en la cookie `cje` (la crea CloudFront)
  public static getCjEvent(): string | undefined {
    return document.cookie.match(/(?:^|; )cje=([^;]+)/)?.[1];
  }

  // CJ Affiliate: añade cjevent al JSON de utms que se envía con la cita
  public static withCjEvent(utms?: string): string | undefined {
    const cjevent = this.getCjEvent();
    if (!cjevent) return utms;
    try {
      return JSON.stringify({ ...JSON.parse(utms || '{}'), cjevent });
    } catch {
      return utms;
    }
  }

  public static trackCjConversion(appointmentId: string) {
    // CJ Affiliate: una conversión por cita, no repetir en recargas ni al editar
    if (!appointmentId || localStorage.getItem('cj_sent') === appointmentId) return;
    const cjevent = this.getCjEvent();
    const w = window as any;
    w.cj = w.cj || {};
    w.cj.order = {
      enterpriseId: 1602379,
      actionTrackerId: 522652,
      orderId: appointmentId,
      pageType: 'conversionConfirmation',
      currency: 'EUR',
      amount: 0,
      items: [{ itemId: 'cita', unitPrice: 0, quantity: 1 }],
      // CJ: omitir cjeventOrder si no hay cookie, nunca enviarlo vacío
      ...(cjevent ? { cjeventOrder: cjevent } : {}),
    };
    const s = document.createElement('script');
    s.src = 'https://www.mczbf.com/tags/1423658827168/tag.js';
    s.async = true;
    document.head.appendChild(s);
    localStorage.setItem('cj_sent', appointmentId);
  }

}